import React, { useEffect } from 'react';

export const useAutoFocus = (
  autoFocus: boolean,
  elementRef: React.RefObject<HTMLInputElement | HTMLTextAreaElement | HTMLDivElement>
) => {
  useEffect(() => {
    if (autoFocus && elementRef.current) {
      elementRef.current.focus();
    }
  }, [autoFocus, elementRef]);
};
